import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const year = new Date().getFullYear();
  const { content } = useContent() || {};
  const f = content?.footer || {};
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <h3
              className="font-display font-light leading-[0.9] tracking-[-0.03em]"
              style={{ fontSize: "clamp(2rem, 5vw, 4.5rem)" }}
            >
              {f.tagline_a || "Until the next"}{" "}
              <span className="italic text-[#c01515]">{f.tagline_emphasis || "cut."}</span>
            </h3>
            <p className="overline mt-6" data-testid="footer-copyright">
              © {year} · {f.copyright || "COPYRIGHT RANJANA SUMAN BARUAH"} · All rights reserved.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="overline mb-4">Channels</p>
            <ul className="space-y-3">
              <li><a data-testid="footer-instagram" href={f.instagram_url || "https://instagram.com"} target="_blank" rel="noreferrer" className="nav-link">Instagram →</a></li>
              <li><a data-testid="footer-linkedin" href={f.linkedin_url || "https://linkedin.com"} target="_blank" rel="noreferrer" className="nav-link">LinkedIn →</a></li>
              {(() => {
                const num = (f.whatsapp_number || "+917002310482").replace(/\D/g, "");
                const msg = encodeURIComponent(f.whatsapp_message || "Hi Ranjana — I came from your portfolio.");
                return num ? (
                  <li>
                    <a
                      data-testid="footer-whatsapp"
                      href={`https://wa.me/${num}?text=${msg}`}
                      target="_blank"
                      rel="noreferrer"
                      className="nav-link"
                    >
                      WhatsApp →
                    </a>
                  </li>
                ) : null;
              })()}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Legal</p>
            <ul className="space-y-3">
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="nav-link">Privacy policy →</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link" className="nav-link">Terms & conditions →</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex items-center justify-between flex-wrap gap-3">
          <span className="overline">{f.tagline_left || "A long lasting memory."}</span>
          <span className="overline">{f.tagline_right || "Crafted in the dark · Guwahati · 26.1°N 91.7°E"}</span>
        </div>
      </div>
    </footer>
  );
}
